(function(){
  // ---- hero carousel ----
  var hero=document.querySelector('[data-hero]');
  if(hero){
    var slides=[].slice.call(hero.querySelectorAll('.hslide'));
    if(slides.length>1){
      var dotsWrap=hero.querySelector('[data-hero-dots]');
      var i=0,timer;
      slides.forEach(function(_,n){
        var b=document.createElement('button');
        b.addEventListener('click',function(){set(n)});
        dotsWrap.appendChild(b);
      });
      function set(n){
        i=(n+slides.length)%slides.length;
        slides.forEach(function(s,k){s.classList.toggle('active',k===i)});
        [].slice.call(dotsWrap.children).forEach(function(d,k){d.classList.toggle('on',k===i)});
        clearInterval(timer);timer=setInterval(function(){set(i+1)},3800);
      }
      var prev=hero.querySelector('[data-hero-prev]'),next=hero.querySelector('[data-hero-next]');
      if(prev)prev.addEventListener('click',function(){set(i-1)});
      if(next)next.addEventListener('click',function(){set(i+1)});
      set(0);
    }
  }

  // ---- product variant picker ----
  var jsonEl=document.querySelector('[data-product-json]');
  var form=document.getElementById('MoltProductForm');
  if(jsonEl&&form){
    var product=JSON.parse(jsonEl.textContent);
    var idInput=form.querySelector('[data-variant-id]');
    var addBtn=form.querySelector('[data-add-btn]');
    var groups=[].slice.call(form.querySelectorAll('[data-option-index]'));
    var selected=[];
    groups.forEach(function(g,gi){
      var on=g.querySelector('.size.on');
      selected[gi]=on?on.getAttribute('data-option-value'):null;
      [].slice.call(g.querySelectorAll('.size')).forEach(function(btn){
        btn.addEventListener('click',function(){
          [].slice.call(g.querySelectorAll('.size')).forEach(function(b){b.classList.remove('on')});
          btn.classList.add('on');
          selected[gi]=btn.getAttribute('data-option-value');
          sync();
        });
      });
    });
    function money(cents){
      return (product.price_currency||'')+(cents/100).toFixed(2);
    }
    function sync(){
      if(selected.some(function(v){return v===null}))return;
      var variant=product.variants.find(function(v){
        return selected.every(function(val,k){return v.options[k]===val});
      });
      if(variant){
        idInput.value=variant.id;
        if(variant.available){
          addBtn.disabled=false;
          addBtn.textContent='Add To Bag — '+(variant.price/100).toLocaleString(undefined,{style:'currency',currency:Shopify&&Shopify.currency?Shopify.currency.active:'GBP'});
        }else{
          addBtn.disabled=true;addBtn.textContent='Sold Out';
        }
      }else{
        addBtn.disabled=true;addBtn.textContent='Unavailable';
      }
    }
    sync();
  }
})();
